"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetQualificationRequest = void 0;
var GetQualificationRequest = /** @class */ (function () {
    function GetQualificationRequest() {
    }
    return GetQualificationRequest;
}());
exports.GetQualificationRequest = GetQualificationRequest;
;
//# sourceMappingURL=getQualification.request.js.map